import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {PaginationStripe} from '@pb/kit-component-pagination';

import {bulkActivityLogsStateActions, bulkActivityLogsStateSelector} from './slices/user-activity-log-state.slice';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    totalCount: number,
};

export const UserActivityLogPagination = ({totalCount}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(bulkActivityLogsStateSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(bulkActivityLogsStateActions.setPageSize(pageSize));
        dispatch(bulkActivityLogsStateActions.setCurrentPage(1));
    }, [dispatch]);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        dispatch(bulkActivityLogsStateActions.setCurrentPage(changedPagination.currentPage));
    }, [dispatch]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={cacheKeys.pagination.pageSize}
            totalCount={totalCount}
            currentPage={cacheKeys.pagination.currentPage}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={[25, 50]}
        />
    );
};
